<script setup lang="ts">
import { RouterView } from 'vue-router'
import { userStore } from './core/stores/user'
import { onMounted, watch } from 'vue'
import { startAuthCheck } from './core/utils/token/token'

const userState = userStore()

onMounted(async () => {
  // Inicializar desde storage (ya se hizo en el guard)
  userState.ensureInitialized()

  // Validar el token con el backend
  if (userState.isAuthenticated) {
    await userState.validateToken()
  }
})

watch(
  () => userState.isAuthenticated,
  (val) => {
    if (val) {
      startAuthCheck()
    }
  },
  { immediate: false },
)
</script>

<template>
  <RouterView />
</template>
